module.exports = __webpack_public_path__ + "static/media/sort-amount-down-alt.c499b526.svg";